/**
 * WebChat 웹앱 엔트리 포인트
 * 독립 웹 채팅 애플리케이션 (SPA 모드)
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './styles/main.css'

// 루트 컴포넌트
import App from './App.vue'

const app = createApp(App)

// Pinia 스토어 설정
app.use(createPinia())

// Vue Router 설정
app.use(router)

// 앱 마운트
app.mount('#app')
